import {
    GET_ENTITY,
    EDIT_ENTITY,
    ADD_ENTITY,
    ALL_ENTITY
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    data: null
  }
  
  const entity = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ENTITY:
            case ADD_ENTITY:
            state = {
              ...state,
              data:action.payload.data,
              loading: false,
            }
            break
        case GET_ENTITY:
            state = {
                ...state,
                loading: true,
            }
            break
        case ALL_ENTITY:
            state = {
                ...state,
                data:action.payload.data,
                loading: false
            }
            break
        default:
            break
    }
    return state
  }

  export default entity
  